export enum EUserType {
    ROOT = 'ROOT',
    ADMIN = 'ADMIN',
    USER = 'USER',
}
